import React from 'react';
import { Helmet } from 'react-helmet-async';
import './AndroidWaitlist.css';

const AndroidWaitlist = () => {
  return (
    <>
      <Helmet>
        <title>Android App Waitlist - OneTimer</title>
        <meta name="description" content="Join the waitlist for OneTimer Android app. Be the first to know when our focus timer app launches on Google Play Store." />
      </Helmet>
      <div className="waitlist-container">
        <div className="waitlist-content">
          <h1>Join the Android Waitlist</h1>
          <p>OneTimer for Android is coming soon! Join our waitlist to be the first to know when it's available.</p>
          <div className="form-container">
            <iframe 
              src="https://docs.google.com/forms/d/e/1FAIpQLSdPDpMliMM9b4TXl6Y1S1AANjcLKH5SARGsmBxav4JB9sEHZw/viewform?embedded=true"
              width="100%"
              height="600"
              frameBorder="0"
              marginHeight="0"
              marginWidth="0"
              title="Android Waitlist Form"
            >
              Loading…
            </iframe>
          </div>
        </div>
      </div>
    </>
  );
};

export default AndroidWaitlist;